import type { MeritSorter } from "./types";

export const byAuthorizedAt: MeritSorter = (meritA, meritB) =>
  (meritA.authorizedAt ?? 0) < (meritB.authorizedAt ?? 0) ? 1 : -1;
